import { useState } from 'react';
import classNames from 'classnames'

const DropZone = ({ className, onDrop: onDropProp, children }) => {
  const [active, setActive] = useState(false);

  function onDragOver(ev){
    ev.preventDefault();
    setActive(true);
  }

  function onDragLeave(ev){
    if (ev.relatedTarget instanceof Node && ev.currentTarget.contains(ev.relatedTarget)) return;
    setActive(false);
  }

  function onDrop(ev){
    ev.preventDefault();
    setActive(false);
    onDropProp?.(ev);
  }

  const classnames = classNames('dropzone', className, {'is-active': active});
  return (
    <span className={classnames}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}>
      {children}
    </span>
  );
}
export default DropZone;
